// Module
var code = "<div class=\"row dev4\"> <div class=\"col-md-12\"> <node-graph-view name=\"a\" directions=\"'all'\" roots=\"['K_NODE;PERSON']\"></node-graph-view> </div> </div> ";
// Exports
export default code;